import {Injectable} from '@angular/core';
import {CrudRepository, toMultipleSelectItem } from '@abydos-angular/store';
import {coalesce, RestResponse, LabelValueVO} from '@abydos-angular/core';
import {map, share, tap} from 'rxjs/operators';
import {forkJoin, Observable, of} from 'rxjs';
import {EventVO,  EventListVO} from './event.interfaces';
import {EventRestService} from '../api/event-rest.service';
import {CategoryRestService} from '@abydos-angular/rest-api';

@Injectable()
export class EventRepository extends CrudRepository<EventVO, EventListVO> {

    constructor(private eventRestService: EventRestService, private categoryRestService: CategoryRestService) {
        super(eventRestService);
    }

    override initSelectItems(): Observable<Map<string, LabelValueVO[]>> {
        return coalesce(this.getCachedSelectItem('initSelectItems'),
            forkJoin([
                this.categoryRestService.listWithParents(['activity_label'])
            ])
        .pipe(
            map(([categoryResponse]) => {
                return {
                    activityLabel: RestResponse.create({
                        status: 'OK',
                        data: categoryResponse.getData()!
                            .filter(value => value.parentCategoryCode === 'activity_label')
                    })
                };
          })
          , toMultipleSelectItem(['activityLabel'])
          , share()
          , tap((itemMap) => {
            this.selectItemCache.set('initSelectItems', itemMap);
          }))
      )!;
    }
}
